var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.291,
    height: 36.291,
    viewBox: "0 0 36.291 36.291",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "comment",
    transform: "translate(-4828.627 -2167.486)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_29",
    "data-name": "Ellipse 29",
    cx: 18.145,
    cy: 18.145,
    r: 18.145,
    transform: "translate(4828.627 2167.486)",
    fill: "#5181f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_440",
    "data-name": "Path 440",
    d: "M25.784,21.017a11.006,11.006,0,1,0-4.766,4.768l4.74,1.185a1,1,0,0,0,1.212-1.213l-1.186-4.74Zm-2.033.11.874,3.5-3.5-.875a1.006,1.006,0,0,0-.731.1A9.011,9.011,0,1,1,23.849,20.4a1,1,0,0,0-.1.732Z",
    transform: "translate(4830.627 2169.486)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.25628c6e76cf7faafe75ab4efa5e51d5.svg";
export { ForwardRef as ReactComponent };